<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <CIcon name="cil-check"/>
            <strong> Percentual de informações enviadas no checklist </strong>
          </CCardHeader>
          <CCardBody>
            <CProgress
              :value="progressBar"
              color="success"
              striped
              class="mb-2"
              show-percentage
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    data() {
      return {
        progressBar: 0
      }
    },
    computed: {
      termoAceite: {
        get () {
          return this.$store.state.aceite
        }
      },
      pagamento: {
        get () {
          return this.$store.state.pagamento
        }
      },
      marketing: {
        get () {
          return this.$store.state.marketing
        }
      },
      logistica: {
        get () {
          return this.$store.state.logistica
        }
      },
      faturamento: {
        get () {
          return this.$store.state.faturamento
        }
      },
      dominio: {
        get () {
          return this.$store.state.dominio
        }
      },
      dados: {
        get () {
          return this.$store.state.dados
        }
      },
      atendimento: {
        get () {
          return this.$store.state.atendimento
        }
      },
      apps: {
        get () {
          return this.$store.state.apps
        }
      },
      aparencia: {
        get () {
          return this.$store.state.aparencia
        }
      }
    },
    mounted() {
      const items = [this.termoAceite, this.pagamento, this.marketing, this.logistica, this.faturamento, this.dominio, this.dados, this.atendimento, this.apps, this.aparencia];

      for (let i = 0; i <= items.length - 1; i++) {
        const contador = Object.entries(items[i]).length;
        if (contador > 0) {
          const keys = Object.keys(items[i]);
          let count = 0;
          keys.forEach(key => {
            if(items[i][key] === undefined || items[i][key] === ""){
              count++;
            }
          });
          if (count == 0) {
            this.progressBar+=10;
          }
        }
      }
    }
  }
</script>
